import React from "react";
import { imageCodes, titleCodes, textCodes, videoCodes } from "../../template_codes/herdotandco/home_page_codes";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import logo from "../../assets/images/herdotandco/her.png";

function Home() {
    return (
        <React.Fragment>
            <div className="font-quicksand" data-theme="weireframe">
                <div class="navbar ">
                    <div class="navbar-start">

                    </div>
                    <div class="navbar-center lg:flex">
                        <ul class="menu menu-horizontal p-0">
                            <li className="p-2"><Link to={paths.home}>Home</Link></li>
                            <li><a href="https://herandcomm.com/">Shop</a></li>
                            <li className="p-2"><Link to={paths.about}>About Us</Link></li>
                            <li className="p-2"><Link to={paths.contact}>Contact</Link></li>
                        </ul>
                    </div>
                    <div className="navbar-end"></div>

                </div>

                {/*            homepage slider section              */}
                <div className="w-full pt-10 bg-ban bg-no-repeat bg-cover">
                    <div className="pt-40 pb-40 text-center">
                        <h1 className="text-3xl pb-10 text-white">Small Business . Big Heart</h1>
                        <button class="btn btn-outline btn-white text-white"><a href="https://herandcomm.com/">S h o p N o w </a></button>
                    </div>

                </div>

                {/*            end of homepage slider section              */}

                {/*                      Categories Section                        */}
                <div className="pt-20 pb-10 px-10 md:px-14 lg:px-32 xl:px-44">
                    <h1 className="text-2xl md:text-3xl lg:text-3xl xl:text-4xl text-center pb-10 font-semibold">{titleCodes.title8.title}</h1>
                    </div>
                    <div class="carousel carousel-center lg:pl-40 xl:pl-40 max-w-full p-4 space-x-10 rounded-box">
                        <div class="carousel-item">
                            <a href="https://herandcomm.com/">
                                <img src={imageCodes.catego.image} className="rounded-full w-28 h-28 place-items-center"></img>
                                <p className="text-md text-base md:pt-4 text-center">Anklet</p>
                            </a>
                        </div>
                        <div class="carousel-item">
                            <a href="https://herandcomm.com/">
                                <img src={imageCodes.catego1.image} className="rounded-full w-28 h-28 place-items-center"></img>
                                <p className="text-md text-base md:pt-4 text-center">Bracelet</p>
                            </a>
                        </div>
                        <div class="carousel-item">
                            <a href="https://herandcomm.com/">
                                <img src={imageCodes.catego2.image} className="rounded-full w-28 h-28 place-items-center"></img>
                                <p className="text-md text-base md:pt-4 text-center">Charms Necklaces</p>
                            </a>
                        </div>
                        <div class="carousel-item">
                            <a href="https://herandcomm.com/">
                                <img src={imageCodes.catego3.image} className="rounded-full w-28 h-28 place-items-center"></img>
                                <p className="text-md text-base md:pt-4 text-center">Choker</p>
                            </a>
                        </div>
                        <div class="carousel-item">
                            <a href="https://herandcomm.com/">
                                <img src={imageCodes.catego4.image} className="rounded-full w-28 h-28 place-items-center"></img>
                                <p className="text-md text-base md:pt-4 text-center">Earrings</p>
                            </a>
                        </div>
                        <div class="carousel-item">
                            <a href="https://herandcomm.com/">
                                <img src={imageCodes.catego5.image} className="rounded-full w-28 h-28 place-items-center"></img>
                                <p className="text-md text-base md:pt-4 text-center">Pearls</p>
                            </a>
                        </div>
                        <div class="carousel-item">
                            <a href="https://herandcomm.com/">
                                <img src={imageCodes.catego6.image} className="rounded-full w-28 h-28 place-items-center"></img>
                                <p className="text-md text-base md:pt-4 text-center">Ring</p>
                            </a>
                        </div>
                    </div>
                
                {/*                    end of Categories Section                   */}

                {/*                 best seller section                */}
                <div className="w-fix">
                    <div className="pt-10 lg:pt-10 xl:pt-10">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">{titleCodes.title1.title}</h1>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 pb-14 place-items-center gap-1 lg:gap-0 xl:gap-0">
                        <div className="pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 shadow-xl hover:animate-pulse">
                                <a href="https://herandcomm.com/product/7NDaDAfq3wq9w2nVhRBQ"><figure><img src={imageCodes.items.image} alt="Date Set" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Alphabet Necklace
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                        <div class="badge badge-outline">Products</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://herandcomm.com/product/uCaLlF9p0bwhkSh1nQSR"><figure><img src={imageCodes.items1.image} alt="blazer" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Oval Hoop

                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                        <div class="badge badge-outline">Products</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://herandcomm.com/product/cl32pbjvz20963501s6884ziosq"><figure><img src={imageCodes.items2.image} alt="Tee" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Mini Huggies

                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                        <div class="badge badge-outline">Products</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://herandcomm.com/product/v7xOUXeB3Bvg7ro3ajtO"><figure><img src={imageCodes.items3.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Tiny Rect Hoop

                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                        <div class="badge badge-outline">Products</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://herandcomm.com/product/c0jRQe8QA4SEwHrtK6gd"><figure><img src={imageCodes.items4.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Let's Shine With Chain

                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                        <div class="badge badge-outline">Products</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*                  end of best seller section                */}


                {/*                        limited collections section                        */}
                <div className="w-fix">
                    <div className="pt-10 lg:pt-10 xl:pt-10">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">{titleCodes.title2.title}</h1>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 pb-20 lg:px-20 xl:px-20 px-4">
                        <div className="lg:pr-2 xl:pr-2 focus-visible">
                            <img src={imageCodes.limited.image}></img>
                            <a href="https://herandcomm.com/product/CyMj3gtPdgdjXibm0uhL"><p className="py-4 hover:animate-bounce">Moon Embracing The Sun  ───</p></a>
                        </div>
                        <div className="lg:pl-2 xl:pl-2">
                            <img src={imageCodes.limited1.image}></img>
                            <a href="https://herandcomm.com/product/sGJg3r9VsbnUkQAXol2k"><p className="py-4 hover:animate-bounce">Mogyok Raw Gemstone Collection ───</p></a>
                        </div>
                        <div className="lg:pl-2 xl:pl-2">
                            <img src={imageCodes.limited2.image}></img>
                            <a href="https://herandcomm.com/product/cl4wcxsie6791601s6xum6r2m6"><p className="py-4 hover:animate-bounce">Pupa Hoop ───</p></a>
                        </div>
                    </div>
                </div>
                {/*                        end of limited collections section                        */}

                {/*                        hero product section                        */}
                <div className="w-fix">
                    <div className="grid grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 pb-20 lg:px-20 xl:px-20 px-4">
                        <div className="text-center pt-10 lg:pt-40 xl:pt-40 lg:pr-2 xl:pr-2 focus-visible">
                            <h1 className="pr-2 lg:text-2xl xl:text-2xl"> Make it yours ❤️</h1>
                            <p className="text-sm pt-5 lg:text-xl xl:text-xl lg:pt-10 xl:pt-10">High Quality Gold Plated Jewellery Store In Myanmar</p>
                        </div>
                        <div className="lg:pl-2 xl:pl-2">
                            <img src={imageCodes.hero.image}></img>
                            <a href="https://herandcomm.com/product/sGJg3r9VsbnUkQAXol2k"></a>
                        </div>
                    </div>
                </div>
                {/*                        end of hero product section               */}

                {/*                 new arrival section                */}
                <div className="w-fix">
                    <div className="lg:pt-10 xl:pt-10">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">{titleCodes.title3.title}</h1>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 pb-14 place-items-center gap-1 lg:gap-0 xl:gap-0">
                        <div className="pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 shadow-xl hover:animate-pulse">
                                <a href="https://herandcomm.com/product/7NDaDAfq3wq9w2nVhRBQ"><figure><img src={imageCodes.new.image} alt="Date Set" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Crystal Hoop
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                        <div class="badge badge-outline">Products</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://herandcomm.com/product/uCaLlF9p0bwhkSh1nQSR"><figure><img src={imageCodes.new1.image} alt="blazer" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Crystal Necklace
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                        <div class="badge badge-outline">Products</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://herandcomm.com/product/cl32pbjvz20963501s6884ziosq"><figure><img src={imageCodes.new2.image} alt="Tee" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Oval Link Choker
                                    </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                        <div class="badge badge-outline">Products</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://herandcomm.com/product/v7xOUXeB3Bvg7ro3ajtO"><figure><img src={imageCodes.new3.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        One Layer Necklace </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                        <div class="badge badge-outline">Products</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" pb-10">
                            <div class="card w-78 md:w-64 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
                                <a href="https://herandcomm.com/product/c0jRQe8QA4SEwHrtK6gd"><figure><img src={imageCodes.new4.image} alt="Tote Bag" /></figure></a>
                                <div class="card-body">
                                    <h5 class="card">
                                        Enamel Chain Anklet </h5>
                                    <div class="card-actions justify-end">
                                        <div class="badge badge-outline">Fashion</div>
                                        <div class="badge badge-outline">Products</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*                  end of best seller section                */}



                {/*                        hers section                        */}
                <div className="w-fix">
                    <div className="lg:pt-0 xl:pt-0">
                        <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">{titleCodes.title4.title}</h1>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 pb-20  lg:px-20 xl:px-20 px-4">
                        <div className="lg:pr-2 xl:pr-2 shadow-xl focus-visible">
                            <img src={imageCodes.her.image}></img>
                            <a href="https://herandcomm.com/product/CyMj3gtPdgdjXibm0uhL"></a>
                        </div>
                        <div className="lg:pl-2 xl:pl-2 shadow-xl">
                            <img src={imageCodes.her1.image}></img>
                            <a href="https://herandcomm.com/product/sGJg3r9VsbnUkQAXol2k"></a>
                        </div>
                        <div className="lg:pl-2 xl:pl-2 shadow-xl">
                            <img src={imageCodes.her2.image}></img>
                            <a href="https://herandcomm.com/product/cl4wcxsie6791601s6xum6r2m6"></a>
                        </div>
                    </div>
                </div>
                {/*                        end of hers section                        */}

                {/*                collaboration brand                      */}
                <div className="items-center text-center w-full bg-[#ffffff]">
                    <div>
                        <div className="text-center pt-10">
                            <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center">{titleCodes.title5.title}</h1>
                        </div>
                    </div>
                    <div className="grid lg:text-center xl:text:centerlg:grid-cols-3 xl:grid-cols-3 gap-0">
                        <div></div>
                        <div className="grid grid-cols-4 text-center pt-4">
                            <div class="avatar text-center">
                                <div class="w-30 rounded text-center">
                                    <img src={imageCodes.asteria.image} className="text-center" />
                                </div>
                            </div>
                            <div class="avata text-center">
                                <div class="w-30 rounded md:text-center">
                                    <img src={imageCodes.littleOdd.image} className="md:text-center" />
                                </div>
                            </div>
                            <div class="avatar text-center">
                                <div class="w-30 rounded text-center">
                                    <img src={imageCodes.your.image} className="text-center" />
                                </div>
                            </div>
                            <div class="avatar text-center">
                                <div class="w-30 rounded md:text-center">
                                    <img src={imageCodes.yangoods.image} className="md:text-center" />
                                </div>
                            </div>
                        </div>
                        <div>
                        </div>
                    </div>
                </div>
                {/*              end of collaboration brand                      */}


            </div>
        </React.Fragment>
    );
}

export default Home;